import React from 'react';

const RelatedUrlLabel = ({ hasChromeExtension, hasWebWidget }) => (
  <>
    {hasChromeExtension &&
      hasWebWidget &&
      t(
        'settings.tab.roles.edit.chrome_extension_and_web_widget_mappings_label',
      )}
    {!hasChromeExtension &&
      hasWebWidget &&
      t('settings.tab.roles.edit.web_widget_mappings_label')}
    {hasChromeExtension &&
      !hasWebWidget &&
      t('settings.tab.roles.edit.chrome_extension_mappings_label')}
  </>
);

export default RelatedUrlLabel;
